import React, { useEffect, useState } from "react"; // Import necessary React hooks
import { links } from "./resources/LinksData"; // Import the links data for the LinkTree
import profileImage from './img/Designer (9).jpeg'; // Import the profile image
import './index.css';

// Cursor Trail Component
const CursorTrail = ({ points }) => {
  return (
    <>
      {points.map((point, index) => (
        <div
          key={index}
          className="cursor-trail"
          style={{
            left: `${point.x}px`,
            top: `${point.y}px`,
            opacity: 1 - index / points.length,
          }}
        />
      ))}
    </>
  );
};

// LinkTree Component
const LinkTree = () => {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const newPoint = { x: event.clientX, y: event.clientY };
      setPoints((prevPoints) => {
        const updatedPoints = [...prevPoints, newPoint];
        return updatedPoints.length > 20 ? updatedPoints.slice(1) : updatedPoints;
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-white p-5 relative">
      <CursorTrail points={points} />
      <div className="hero text-center mb-8">
        <img src={profileImage} alt="profile" className="w-24 h-24 rounded-full mx-auto border-4 border-white" />
        <h1 className="text-3xl font-bold mt-4">Coretta K. Dawani</h1>
        
        {/* Quote without Background */}
        <p className="quote-text text-lg italic text-gray-200 font-medium mt-4">
          "From every ruin, life springs anew. And from the ashes of destruction, a phoenix will rise."
        </p>
        <p className="quote-author text-right text-sm text-gray-400">- Sherrilyn Kenyon</p>
      </div>

      <div className="w-full max-w-md">
        {links.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-btn" // Use the new link-btn class
          >
            <span className="mr-3" style={{ color: link.iconColor }}>{link.icon}</span>
            {link.title}
          </a>
        ))}
      </div>
      <footer className="text-xs mt-8">
        <p className="mt-2">&copy;CorettaDawani {new Date().getFullYear()}. Designed by <a href="mailto:ckd263@yahoo.com" className="underline">CKD263</a>. All rights reserved.</p>
      </footer>
    </div>
  );
};

// App Component
const App = () => {
  return <LinkTree />;
};

export default App;
